import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/styles/main.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Post from "./pages/Post";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/post/:blogId" element={<Post />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
